var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LRLayout',{staticClass:"lr_layout_out"},[_c('LeftPanel',{staticClass:"layout_left_panel",staticStyle:{"overflow":"auto"}},[_c('ArticleCateTree')],1),_c('RightPanel',{staticClass:"layout_right_panel"},[_c('ArticleList',{attrs:{"type":_vm.type}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }